export const formatDate = date => {
  const YYYY = date.split('/')[2];
  const MM = date.split('/')[1];
  const DD = date.split('/')[0];

  return `${YYYY}-${MM}-${DD}`;
};

export const formatDateHyphen = date => {
  const YYYY = date.split('-')[2];
  const MM = date.split('-')[1];
  const DD = date.split('-')[0];

  return `${YYYY}-${MM}-${DD}`;
};

export const dateToString = date => {
  const Y = date.getFullYear();
  const M = date.getMonth();
  const D = date.getDate();
  return `${Y}-${M + 1 < 10 ? `0${M + 1}` : M + 1}-${D < 10 ? `0${D}` : D}`;
};
